import React from "react";
import { useNavigate } from "react-router-dom";
export default function SubCategoriaEncontrada({ nombre, totalCursos, id }) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/cursos?page=1&page_size=10&categoria_ids=${id}`);
    window.location.reload();
  };
  return (
    <>
      <div
        data-figma-id="5381:19933"
        className="menu-organizacion-ejemplo"
        onClick={handleNavigate}
      >
        <p
          data-figma-id="5381:19935"
          className="menu-organizacion-ejemplo-texto"
        >
          {nombre}
        </p>
        <div className="div-block-13">
          <i
            className="fi fi-rr-apps icon-categoria"
            data-figma-id="113:9509"
          ></i>
          <div className="text-block">{totalCursos}</div>
        </div>
      </div>
    </>
  );
}
